import { ActionTypes } from "./../actions/index";
import { SketchState } from '../states';
import { SketchActions } from "../actions/sketch";
import { SketchStateEnum } from "../../models";

const getInitialState = (): SketchState => {
    return {
        id: null,
        activeTool: null,
        state: SketchStateEnum.idle
    };
};

const cobrowse = (state = getInitialState(), action: ActionTypes): SketchState => {
    switch (action.type) {
        case SketchActions.STARTED:
            return { ...state, id: action.payload, state: SketchStateEnum.started }
        case SketchActions.ENDED:
            return getInitialState();
        case SketchActions.TOOL_CHANGED:
            return { ...state, activeTool: action.payload }
    }
    return state;
}

export default cobrowse;